export const stopScroll = () => {
  if (document) {
    const body = document.getElementsByTagName('body')[0]
    body.classList.add('disable-scroll')
  }
}

export const stopElementScroll = (el: HTMLElement) => {
  if (el) {
    el.classList.add('disable-scroll')
  }
}

export const continueScroll = () => {
  if (document) {
    const body = document.getElementsByTagName('body')[0]
    body.classList.remove('disable-scroll')
  }
}

export const continueElementScroll = (el: HTMLElement) => {
  if (el) {
    el.classList.remove('disable-scroll')
  }
}

export const scrollToTab = (
  scroll: HTMLElement,
  container: HTMLElement,
  i: number,
  smooth: boolean = true
) => {
  const btn = container.children[i] as HTMLButtonElement
  const btnWidth = btn.getBoundingClientRect().width / 2
  const offset = btn.offsetLeft - (container.getBoundingClientRect().width / 2 - btnWidth)

  scroll.scrollTo({
    left: offset,
    behavior: smooth ? 'smooth' : 'instant'
  })
}

export const scrollToSection = (el: HTMLElement, offset: number = -110) => {
  if (window) {
    window.scrollTo({
      top: el?.offsetTop + offset,
      behavior: 'smooth'
    })
  }
}

type useScrollReturnType = {
  scrollToTab: typeof scrollToTab
  scrollToSection: typeof scrollToSection
  stopScroll: typeof stopScroll
  continueScroll: typeof continueScroll
  stopElementScroll: typeof stopElementScroll
  continueElementScroll: typeof continueElementScroll
}

export function useScroll(): useScrollReturnType {
  return {
    scrollToTab,
    scrollToSection,
    stopScroll,
    continueScroll,
    stopElementScroll,
    continueElementScroll
  }
}
